import React, { FunctionComponent, useEffect, useState } from "react";
import { Grid, Typography } from "@material-ui/core";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Box from "@material-ui/core/Box";
import { useStore } from "../../store";
import { useDivisionStyles } from "./useDivisionStyles";
import { DivisionTableList } from "./DivisionList/DivisionTableList";
import { Helmet } from "react-helmet-async";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}
type permissionType = {
  permission_id: number;
  is_add: boolean;
  is_edit: boolean;
  is_view: boolean;
  is_delete: boolean;
};
export const TabPanel: FunctionComponent<TabPanelProps> = ({
  children,
  value,
  index,
}) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      //   {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
};

export const DivisionMaster = () => {
  const classes = useDivisionStyles();
  const [value, setValue] = React.useState(0);
  const [viewDivisionPermission, setViewDivisionPermission] = useState<boolean>(
    false
  );
  const [editDivisionPermission, setEditDivisionPermission] = useState<boolean>(
    false
  );
  const [user] = useStore("auth", "user");

  useEffect(() => {
    const divisionPermission = user.permissions.find(
      (permission: permissionType) => permission.permission_id === 6
    );
    if (user.is_super_admin === true) {
      setViewDivisionPermission(true);
      setEditDivisionPermission(true);
    } else {
      if (divisionPermission) {
        if (divisionPermission.is_edit === true) {
          setEditDivisionPermission(true);
        }
        if (divisionPermission.is_view === true) {
          setViewDivisionPermission(true);
        }
      }
    }
  });

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
  };

  return (
    <>
      <Helmet>
        <title>Divisions</title>
      </Helmet>
      <Grid
        container
        spacing={2}
        direction="row"
        justify="space-between"
        alignItems="center"
      >
        <Grid item xs={12} className={classes.root}>
          <AppBar position="static">
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="simple tabs example"
            >
              <Tab
                label="Division List"
                style={{ display: viewDivisionPermission ? "" : "none" }}
              />
            </Tabs>
          </AppBar>
          <TabPanel value={value} index={0}>
            <DivisionTableList
              editDivisionPermission={editDivisionPermission}
            />
          </TabPanel>
        </Grid>
      </Grid>
    </>
  );
};
